enum TicketActionType {
	GET_TICKET_QTY_REQUEST = 'GET_TICKET_QTY_REQUEST',
	GET_TICKET_QTY_SUCCEEDED = 'GET_TICKET_QTY_SUCCEEDED',
	GET_TICKET_QTY_FAILED = 'GET_TICKET_QTY_FAILED',
}

export default TicketActionType;

